export const getColor = (val: number) => {
  // 0도(파랑) ~ 38도(빨강) - 9단계로 세분화
  if (val <= 4)
    return {
      solid: '#5F7ADB', // Dark Blue
      gradient: 'linear-gradient(90deg, #5F7ADB, #5F7ADB)',
    };
  if (val <= 8)
    return {
      solid: '#3498DB', // Medium Blue
      gradient: 'linear-gradient(90deg, #5F7ADB, #3498DB)',
    };
  if (val <= 12)
    return {
      solid: '#1ABC9C', // Cyan / Aqua
      gradient: 'linear-gradient(90deg, #5F7ADB, #3498DB, #1ABC9C)',
    };
  if (val <= 16)
    return {
      solid: '#7AC4B3', // Mint (Green)
      gradient: 'linear-gradient(90deg, #5F7ADB,#3498DB, #1ABC9C, #7AC4B3)',
    };
  if (val <= 20)
    return {
      solid: '#2ECC71', // Lime Green
      gradient: 'linear-gradient(90deg, #5F7ADB,#3498DB, #1ABC9C, #7AC4B3, #2ECC71)',
    };
  if (val <= 24)
    return {
      solid: '#F1C40F', // Yellow
      gradient: 'linear-gradient(90deg, #5F7ADB,#3498DB, #1ABC9C, #7AC4B3, #2ECC71, #F1C40F)',
    };
  if (val <= 28)
    return {
      solid: '#F39C12', // Orange
      gradient:
        'linear-gradient(90deg, #5F7ADB,#3498DB, #1ABC9C, #7AC4B3, #2ECC71, #F1C40F, #F39C12)',
    };
  if (val <= 32)
    return {
      solid: '#E67E22', // Dark Orange
      gradient:
        'linear-gradient(90deg, #5F7ADB,#3498DB, #1ABC9C, #7AC4B3, #2ECC71, #F1C40F, #F39C12, #E67E22)',
    };
  return {
    solid: '#E65C5C', // Red
    gradient:
      'linear-gradient(90deg, #5F7ADB,#3498DB, #1ABC9C, #7AC4B3, #2ECC71, #F1C40F, #F39C12, #E67E22, #E65C5C)',
  };
};
